export enum APP_EVENT_KEY {
  SHOW_LOGOUT_WARNING = 'show_logout_warning',
  TOGGLE_NAV_MENU = 'toggle_nav_menu',
  TIME_LEFT = 'time_left',
  LOGOUT = 'logout',
  LOGOUT_BY_TIMEOUT = 'logout_by_timeout',
  THEME_TOGGLE = 'theme_toggle',
  COMPANY_SELECTED = 'company_selected',
}

export const EVENT_KEY = 'key';
export const EVENT_VALUE = 'value';

export interface APP_EVENT {
  [EVENT_KEY]: string;
  [EVENT_VALUE]?: JSONValue;
}

export type JSONValue = string | number | boolean | null | Date | JSONObject | JSONArray;

export interface JSONObject {
  [key: string]: JSONValue;
}

export type JSONArray = JSONValue[];

export enum WORKER_ACTION {
  STOP = 'stop',
  START = 'start',
}

export enum THEME {
  LIGHT = 'light',
  DARK = 'dark',
}

// See SettingKeyEnum.cs
export const APP_TIMEOUT_SETTING_KEY = 2000;
export const APP_WARNING_TIMEOUT_SETTING_KEY = 2001;
export const PRODUCT_ITEMS_SEARCH_MAX_NUMBER_OF_PRODUCT_IDS_SETTING_KEY = 5004;
export const PRODUCT_ITEMS_SEARCH_MAX_NUMBER_OF_ROWS_FOR_GRID_DISPLAY_SETTING_KEY = 5005;
export const PRODUCT_ITEMS_SEARCH_PRODUCT_ID_MIN_LENGTH_SETTING_KEY = 5006;
export const PRODUCT_ITEMS_SEARCH_PRODUCT_ID_MAX_LENGTH_SETTING_KEY = 5007;
export const PRODUCT_ITEMS_SEARCH_PRODUCT_DESCRIPTION_MIN_LENGTH_SETTING_KEY = 5008;
export const PRODUCT_ITEMS_SEARCH_PRODUCT_DESCRIPTION_MAX_LENGTH_SETTING_KEY = 5009;
export const AUDIT_ITEMS_SEARCH_MAX_NUMBER_OF_PRODUCT_IDS_SETTING_KEY = 6004;
export const AUDIT_ITEMS_SEARCH_MAX_NUMBER_OF_ROWS_FOR_GRID_DISPLAY_SETTING_KEY = 6005;
export const AUDIT_ITEMS_SEARCH_PRODUCT_ID_MIN_LENGTH_SETTING_KEY = 6006;
export const AUDIT_ITEMS_SEARCH_PRODUCT_ID_MAX_LENGTH_SETTING_KEY = 6007;

// Will be used if settings endpoint doesnt return anything
export const DEFAULT_APP_TIMEOUT = 60 * 30 + 1;
export const DEFAULT_APP_WARNING_TIMEOUT = 60 * 5;

export enum CONTEXT_KEY {
  USER = 'user',
  SETTINGS = 'settings',
}

export enum DATE_TIME_FORMAT {
  TIME = 'mm:ss',
  TIME_FULL = 'HH:mm:ss',
  DATE = 'DD-MMM-YYYY',
  DATE_TIME = 'DD-MMM-YYYY HH:mm:ss',
  DATE_TIME_SHORT = 'DD-MM-YYYY HH:mm',
  DATE_SHORT = 'DD-MM-YYYY',
  FULL = 'HH:mm a | dd MMMM YYYY',
  DATE_TIME_FULL_SLASH = 'dd/MMM/YYYY, hh:mm a',
  DATE_FILTER_FORMAT = 'dd/MMM/yyyy',
  MONTH_YEAR = 'MMM yyyy',
}

export const ACTIVITY_EVENTS = ['keydown', 'click'] as const;

export const PRIVACY_NOTICE_ENDPOINT = '/PrivacyNotice/current';
export const PRIVACY_NOTICE_ACK_ENDPOINT = '/PrivacyNotice/ack';
export const SETTINGS_ENDPOINT = '/Settings';
export const USER_PROFILE_ENDPOINT = '/User/profile';
export const COMPANY_SETTINGS_ENDPOINT = '/Company/current';
